import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { AccountsGridDataProviderFactory } from '../factory/AccountsGridDataProviderFactory';
import { AccountsGridBaseDataProvider } from '../dataProvider/AccountsGridBaseDataProvider';
import { AccountsGridViewData } from '../types';

export class AccountsGridRepository extends BaseWebComponentRepository {
  public dataProviderFactory: AccountsGridDataProviderFactory;
  public dataProvider: AccountsGridBaseDataProvider;

  constructor() {
    super();

    this.initialSetup({
      dataProviderFactory: new AccountsGridDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<AccountsGridViewData> {
    return this.dataProvider.getDataForView();
  }
}
